export default __webpack_public_path__ + "static/media/BentonSans-Regular.a9caa50e.otf";